import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Footer } from "@/components/Footer";
import { useSeo } from "@/lib/useSeo";
import { ArrowLeft } from "lucide-react";

export default function Termini() {
  useSeo({
    title: "Termini del Servizio — SuiteCrowd",
    description:
      "Termini e condizioni completi di SuiteCrowd: natura del servizio, tutela dei fondi in conto escrow, garanzia di rimborso e regole di utilizzo del voucher soggiorno.",
    canonical: "https://suitecrowd.com/termini",
  });

  return (
    <div className="min-h-screen bg-white text-[#121212]">
      <nav className="border-b border-[#E5E5E5] bg-white/80 backdrop-blur-md sticky top-0 z-30">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex justify-between items-center">
          <Logo variant="dark" size="md" />
          <Link to="/" className="text-[11px] tracking-[0.24em] uppercase text-neutral-500 hover:text-[#121212] inline-flex items-center gap-2 transition-colors">
            <ArrowLeft size={14} /> Home
          </Link>
        </div>
      </nav>

      <article className="max-w-3xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="sc-overline mb-6">Documento legale</div>
        <h1 className="font-display font-light text-4xl md:text-5xl mb-4" style={{ letterSpacing: "-0.03em" }}>
          Termini del Servizio
        </h1>
        <p className="text-sm text-neutral-500 mb-16">
          Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT", { year: "numeric", month: "long", day: "numeric" })}
        </p>

        <div className="space-y-14 text-[15px] leading-[1.85] text-neutral-700">
          <section>
            <h2 className="font-display text-xl font-normal text-[#121212] mb-4" style={{ letterSpacing: "-0.01em" }}>
              1. Natura del Servizio
            </h2>
            <p>
              SuiteCrowd è una piattaforma tecnologica che facilita il pre-acquisto
              di servizi turistici futuri sotto forma di micro-finanziamento
              collettivo (crowdfunding). Non costituisce un'attività di
              sollecitazione al pubblico risparmio o un prodotto finanziario
              speculativo. L'utente riconosce che la quota versata rappresenta un
              contributo alla realizzazione di un progetto turistico e non un
              investimento a rendimento.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-normal text-[#121212] mb-4" style={{ letterSpacing: "-0.01em" }}>
              2. Tutela dei Fondi (Conto Escrow)
            </h2>
            <p>
              La quota di iscrizione/sostegno di 49,00 € versata dall'utente non
              viene incassata direttamente dalla piattaforma né dall'hotel. I fondi
              vengono depositati e congelati in un conto di garanzia indipendente
              (gestito tramite il fornitore di pagamenti autorizzato Stripe/PayPal).
              L'utente riceve conferma dell'avvenuto deposito via email e può
              richiedere in qualunque momento un estratto delle transazioni.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-normal text-[#121212] mb-4" style={{ letterSpacing: "-0.01em" }}>
              3. Garanzia di Rimborso
            </h2>
            <p>
              I fondi saranno svincolati a favore della struttura alberghiera solo
              al raggiungimento del target di raccolta o all'avanzamento certificato
              dei lavori. Nel caso in cui il progetto dell'hotel venga annullato, o
              la struttura non completi la ristrutturazione nei tempi previsti, la
              quota di 49,00 € verrà interamente riaccreditata sul metodo di
              pagamento originario dell'utente, senza necessità di richiesta esplicita.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-normal text-[#121212] mb-4" style={{ letterSpacing: "-0.01em" }}>
              4. Utilizzo del Voucher
            </h2>
            <p>
              Il voucher garantisce un soggiorno di 4 giorni (camera doppia) per
              l'anno solare successivo al completamento dei lavori, utilizzabile
              esclusivamente nei periodi di bassa e media stagione indicati
              dall'hotel. L'utilizzo in alta stagione o nei ponti festivi è soggetto
              a un supplemento monetario obbligatorio da saldare al momento della
              prenotazione effettiva. Il voucher è nominativo e non cedibile a terzi
              se non previa autorizzazione scritta della piattaforma.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-normal text-[#121212] mb-4" style={{ letterSpacing: "-0.01em" }}>
              5. Modifiche e Comunicazioni
            </h2>
            <p>
              SuiteCrowd si riserva il diritto di aggiornare i presenti termini
              comunicando le modifiche via email agli iscritti almeno 30 giorni prima
              dell'entrata in vigore. Per qualsiasi controversia è competente il
              foro italiano di residenza del consumatore.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-normal text-[#121212] mb-4" style={{ letterSpacing: "-0.01em" }}>
              6. Contatti
            </h2>
            <p>
              Per informazioni, richieste di rimborso o esercizio dei diritti previsti
              dalla normativa, scrivi a{" "}
              <a href="mailto:info@suitecrowd.com" className="underline decoration-neutral-400 hover:text-[#0B192C]">
                info@suitecrowd.com
              </a>
              .
            </p>
          </section>
        </div>
      </article>

      <Footer />
    </div>
  );
}
